/**
 * Queue V2 Repository - GraphQL Mutations
 *
 * 7 mutation operations for Queue primitive data modification.
 */

import { gql } from '@apollo/client';
import { QUEUE_FIELDS_FRAGMENT } from './fragments';

export const CREATE_QUEUE = gql`
  ${QUEUE_FIELDS_FRAGMENT}
  mutation CreateQueue($tenantId: String!, $input: CreateQueueInput!) {
    createQueue(tenantId: $tenantId, input: $input) {
      ...QueueFields
    }
  }
`;

export const ENQUEUE_TASK = gql`
  ${QUEUE_FIELDS_FRAGMENT}
  mutation EnqueueTask($tenantId: String!, $queueId: String!, $input: EnqueueTaskInput!) {
    enqueueTask(tenantId: $tenantId, queueId: $queueId, input: $input) {
      ...QueueFields
    }
  }
`;

export const DEQUEUE_TASK = gql`
  mutation DequeueTask($tenantId: String!, $queueId: String!) {
    dequeueTask(tenantId: $tenantId, queueId: $queueId)
  }
`;

export const ASSIGN_TASK = gql`
  ${QUEUE_FIELDS_FRAGMENT}
  mutation AssignTask($tenantId: String!, $queueId: String!, $input: AssignTaskInput!) {
    assignTask(tenantId: $tenantId, queueId: $queueId, input: $input) {
      ...QueueFields
    }
  }
`;

export const PAUSE_QUEUE = gql`
  ${QUEUE_FIELDS_FRAGMENT}
  mutation PauseQueue($tenantId: String!, $queueId: String!) {
    pauseQueue(tenantId: $tenantId, queueId: $queueId) {
      ...QueueFields
    }
  }
`;

export const RESUME_QUEUE = gql`
  ${QUEUE_FIELDS_FRAGMENT}
  mutation ResumeQueue($tenantId: String!, $queueId: String!) {
    resumeQueue(tenantId: $tenantId, queueId: $queueId) {
      ...QueueFields
    }
  }
`;

export const DRAIN_QUEUE = gql`
  ${QUEUE_FIELDS_FRAGMENT}
  mutation DrainQueue($tenantId: String!, $queueId: String!) {
    drainQueue(tenantId: $tenantId, queueId: $queueId) {
      ...QueueFields
    }
  }
`;
